module.exports = __webpack_public_path__ + "static/media/premium-newsltetters.0c34d937.png";